import {pageFilter} from "../../data/page_data";
import CssLoader from "../../components/CssLoader";
import React from "react";
import axios from "axios";
import {Link} from "@reach/router";
import Footer from "../../components/Footer";

import {motion} from 'framer-motion';
import * as ReactGA from "react-ga";

export default class SingleContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data:{}
    }
    this.pageData = pageFilter(this.props.artist, "../");

  }

  componentDidMount() {
    axios.get('/w/api/lp/single/' + this.props.code).then((response) => {
      if (response.data.error) {
        this.setState({error: response.data});
      }
      this.setState({data: response.data});

    });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    console.log('>>', this.state.data);
    return (
        <>
          <CssLoader css={this.pageData.artist.css}/>

          <div className="header">
            <div className={'header-inner'}>
              <div className="header-center">{this.pageData.artist.name}</div>
            </div>
          </div>

          {this.state.data && this.state.data.data && this.state.data.data.content_type === 1 &&

          <div className="content video video-watch"
               style={{position: 'relative'}}
          >
            <motion.div
                animate={{top: 0}}
                initial={{top: '-500px'}}
            >
              {this.state.data.data.image_promo &&
              <div className="event-img">
                <a href={this.state.data.data.link}>
                <img src={this.state.data.data.image_promo}/>
                </a>
              </div>
              }

              <div>
                <video src={this.state.data.data.media_url} style={{marginTop: '2em'}}
                       autoPlay poster={this.state.data.data.image} controls></video>
              </div>

              <div className="container">
                <div className="video-watch-detail">
                  <div className="vwd-top">
                    <h4 style={{textAlign: 'center'}}
                    >{this.state.data.data.title}</h4>
                  </div>
                </div>
              </div>

            </motion.div>
          </div>
          }
          {this.state.data.data && this.state.data.data.content_type === 2 &&

          <motion.div
              animate={{opacity: 1}}
              initial={{opacity: 0}}
              className="content news">

            {this.state.data.data.image_promo &&
            <div className="event-img">
              <a href={this.state.data.data.link}>
                <img src={this.state.data.data.image_promo}/>
              </a>
            </div>
            }

            {this.state.data.banner &&
            <div className="event-img" style={{marginBottom: 24}}>
              <a href={this.state.data.banner.url}>
                <img src={this.state.data.banner.image}/>
              </a>
            </div>
            }

            <div className="news-detail" style={{padding: 0}}>
              {this.state.data.data.media_url ?
                  <div className="video video-watch">
                    <div>
                      <video src={this.state.data.data.media_url}
                             poster={this.state.data.data.image} controls>
                      </video>
                    </div>
                  </div>
                  :
                  <div className="container" style={{marginTop: '2em'}}>
                    <div className="news-detail-img">
                      <img src={this.state.data.data.image}/>
                    </div>
                  </div>
              }
            </div>

            <div className="container">
              <div className="news-detail-text">
                <div className="text-title">{this.state.data.data.title}</div>
                {this.state.data.data.description.split('\n').map((item, index) => {
                  return <p>{item}</p>
                })

                }
              </div>
            </div>
          </motion.div>
          }

          {this.state.data.data && this.state.data.data.content_type === 3 &&
          <>
            {this.state.data.data.image_promo &&
            <div className="event-img">
              <a href={this.state.data.data.link}>
                <img src={this.state.data.data.image_promo}/>
              </a>
            </div>
            }
          <div className="photo-full">
            {this.state.data.banner &&
            <div className="event-img" style={{marginBottom: 24}}>
              <a href={this.state.data.banner.url}>
                <img src={this.state.data.banner.image}/>
              </a>
            </div>
            }
            <h3 className="photo-title">{this.state.data.data.title}</h3>
            <img className="photo-img" src={this.state.data.data.image}/>
          </div>

          </>
          }

          {this.state.data && this.state.data.error &&
          <div className="photo-full" style={{position: 'relative'}}>
            <motion.div
                animate={{y: '-50%', top: '50%'}}
                initial={{top: -100}}
                style={{
                  fontWeight: 'bold',
                  fontSize: '2em',
                  lineHeight: '1',
                  textAlign: 'center',
                  width: '100%',
                  color: '#444',
                  position: 'absolute'
                }}
            >
              {this.state.data.error}

            </motion.div>
          </div>
          }


          <Footer/>

        </>
    );
  }
}